module.exports = __webpack_public_path__ + "static/media/home-ana-awards.52be1f32.png";